/* eslint-disable react/react-in-jsx-scope */
/* eslint-disable react/prop-types */
import './footer.css';

function Footer() {
    return (
        <footer className='Footer'>
            <h3>Copyright © 2024 George Novelli Tarlazis</h3>
        </footer>
    )
}

export default Footer;